module.exports = __webpack_public_path__ + "static/media/corona.b8d970d9.png";